import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import createPersistedState from "vuex-persistedstate";
import pjson from "../../package.json";

Vue.use(Vuex);
let uuid = null,
  control_group = null,
  control_flag = null,
  dndTourDone = false;

var pref = "shopbox-app";
var key = pref + "-v" + pjson.version;

function remLSPref(pref, newName) {
  for (var key in localStorage) {
    if (key.indexOf(pref) == 0) {
      if (key != newName) {
        let oldStorage = JSON.parse(localStorage.getItem(key));
        uuid = oldStorage.uuid;
        control_group = oldStorage.control_group;
        control_flag = oldStorage.control_flag;
        dndTourDone = oldStorage.dndTourDone;

        localStorage.removeItem(key);
      }
    }
  }
}
remLSPref(pref, key);

export default new Vuex.Store({
  state: {
    // User variables
    uuid: uuid,
    control_group: control_group,
    control_flag: control_flag,
    c_page: null,
    site: "did1",
    client: "did1",
    currency: null,
    currencyCode: null,
    decimalcomma: '.',
    pricer: null,
    cart: [],
    productBannerData: null,
    brand: null,
    // cart: ["20415", "RB29FWRNDSA", "VALBUN41", "24WL3A63DB"],
    // Last searched product
    lastProductId: [],
    // Similar products
    similarProducts: [],
    embedSimilarProducts: [],
    embedRecentProducts: [],
    similarProductsPage: 1,
    similarProductsSize: 3,
    similarEnabled: false,
    dndEnabled: false,
    // REcently viewed products
    recentEnabled: true,
    recentProducts: [],
    recentProductsPage: 1,
    recentProductsSize: 3,
    // Recently Purchased
    purchasedEnabled: true,
    purchasedProducts: [],
    purchasedProductsPage: 1,
    purchasedProductsSize: 3,
    // Cross Sell products
    crosssellProducts: [],
    crosssellWasClosed: false,
    crosssellProductsPage: 1,
    crosssellProductsSize: 3,
    crosssellEnabled: false,
    // Panels
    currentPanelSize: 0,
    portraitview: false,
    panelList: [
      "similarOpen",
      "purchasedOpen",
      "embedSimilarOpen",
      "embedRecentOpen",
      "recentOpen",
      "menuOpen",
      "crosssellOpen",
      "ctaOpen",
    ],
    menuOpen: false,
    similarOpen: false,
    embedSimilarOpen: false,
    embedRecentOpen: false,
    purchasedOpen: false,
    recentOpen: false,
    crosssellOpen: false,
    isMobile: false,
    // CTA
    ctaOpen: false,
    ctaProducts: null,
    ctaHeading: "",
    ctaSubheading: "",
    ctaTimer: "5000",
    ctaAction: null,
    // Notifications
    notificationSimilar: false,
    notificationRecent: false,
    // Loading bool for all panels
    isLoading: false,
    nextLoaderMobile: false,
    stopInfiniteLoad: false,
    // Tours
    basicTourDone: true,
    dndTourDone: dndTourDone,
    crosssellTourDone: true,
    detailsTourDone: true,
    lang: 'en',
    content: {
      en: {
        greet: {
          heading: "Hi <span class=' sb-emoji'>👋</span>",
          body: 'We are your personal shopping assistant'
        },
        buttons: {
          recent: 'You Recently Viewed',
          similar: 'Find Similar',
          details: 'Details',
          back: 'Back',
          next: 'Next',
          exit: 'Exit',
        },
        panels: {
          recent: 'Recently viewed',
          similar: 'Similar Products',
        },
        cta: {
          recent: {
            heading: 'Welcome Back',
            body: "Products you've viewed recently"
          },
          recentMobile: {
            heading: 'Recently Viewed',
          },
          similar: {
            heading: 'Similar Products',

          },
          similarMobile: {
            heading: 'Similar',

          },
        },
        tutorial: {
          stepOne: {
            heading: "<span class=' sb-emoji'>👋</span> Let us show you how it works!",
            body: `We want to show you how we can help you find the right product quicker.</br> This is our drag and drop search`
          },
          stepTwo: {
            heading: "Let's try it out <span class='emoji sb-emoji'>🎉</span>",
            body: `Drag & drop the magnifier glass icon over a product to see similiar products.`
          },
          dnd: `Drag & drop the magnifier glass over a product to see similiar products.`
        },
        errors: {
          last: ` You have reached the last page <b class="emoji sb-emoji">🤷‍♂️</b> <br /> Go back to review previous  <b class="emoji sb-emoji">👈</b>`,
          nosimilar: `No similar products found.. <b class='emoji sb-emoji'>🤷‍♀️</b> </br> You can try again with a new product!`,
          norecent: 'No previous products found!'
        }
      },
      da: {
        greet: {
          heading: "Hej! <span class=' sb-emoji'>👋</span>",
          body: 'Jeg er din personlige shoppingassistent'
        },
        buttons: {
          recent: 'Du har for nylig set',
          similar: 'Se lignende',
          details: 'Se detaljer',
          back: 'tilbage',
          next: 'Næste',
          exit: 'Luk',
        },
        panels: {
          recent: 'Du har for nylig set',
          similar: 'Lignende produkter',
        },
        cta: {
          recent: {
            heading: 'Du har for nylig set',
            body: "Produkter, du har set for nylig"
          },
          recentMobile: {
            heading: 'Recently Viewed',
          },
          similar: {
            heading: 'Lignende produkter',

          },
          similarMobile: {
            heading: 'Lignende',

          },
        },
        tutorial: {
          stepOne: {
            heading: "<span class=' sb-emoji'>👋</span> Lad mig vise dig hvordan det fungerer!",
            body: `Sådan finder du den rigtige gave.</br> Dette er vores drag and drop søgning`
          },
          stepTwo: {
            heading: "Lad os prøve det <span class='emoji sb-emoji'>🎉</span>",
            body: `Drag and drop forstørrelsesglasikonet over et produkt for at se lignende produkter.`
          },
          dnd: `Drag and drop forstørrelsesglasikonet over et produkt for at se lignende produkter.`
        },
        errors: {
          last: `Gå på opdagelse og bliv inspireret  <b class="emoji sb-emoji">😊 💐</b> `,
          nosimilar: `Gå på opdagelse og find den bedste gavehilsen  <b class='emoji sb-emoji'> 😊 💐  </b>`,
          norecent: 'Gå på opdagelse og find den bedste gavehilsen <b class="emoji sb-emoji">😊 💐</b>'
        }
      },
      es: {
        greet: {
          heading: 'Hola! 👋',
          body: 'Somos tu asistente de compras personal'
        },
        buttons: {
          recent: 'Recientemente viste',
          similar: 'Productos similares',
          details: 'Detalles',
          back: 'Back',
          next: 'Siguiente',
          exit: 'Salida',
        },
        panels: {
          recent: 'Recientemente viste',
          similar: 'Productos similares',
        },
        cta: {
          recent: {
            heading: 'Bienvenido de nuevo',
            body: "Productos que has visto recientemente"
          },
          recentMobile: {
            heading: 'Recientemente viste',
          },
          similar: {
            heading: 'Productos similares',

          },
          similarMobile: {
            heading: 'Similares',

          },
        },
        tutorial: {
          stepOne: {
            heading: '👋 ¡Permítanos mostrarle cómo funciona!',
            body: `Queremos mostrarte cómo podemos ayudarte a encontrar el producto adecuado más rápido. </br> Esta es nuestra búsqueda de arrastrar y soltar`
          },
          stepTwo: {
            heading: "Vamos a probarlo 🎉",
            body: `Arrastre y suelte el icono de la lupa sobre un producto para ver productos similares.`
          },
          dnd: `Arrastre y suelte el icono de la lupa sobre un producto para ver productos similares.`
        },
        errors: {
          last: ` Ha llegado a la última página <b class="emoji">🤷‍♂️</b> <br /> Volver a la revisión anterior.  <b class="emoji">👈</b>`,
          nosimilar: `No se han encontrado productos similares.. <b class='emoji'>🤷‍♀️</b> </br> ¡Puede intentarlo de nuevo con un nuevo producto! `,
          norecent: 'No se han encontrado productos similares.'
        }
      },

    }
  },
  actions,
  mutations,
  getters,
  plugins: [createPersistedState({ key: key })],
});
